(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Carousel = global.NewHomeSource.Carousel || {};

  const Carousel = global.NewHomeSource.Carousel;

  if (!Carousel.EventStore) {
    return;
  }

  class KeyboardScroller {
    /**
     * Initializes a new instance of the class.
     * Sets the initial state to null.
     */
    constructor() {
      this.state = null;
      this.keyboardEvents = new Carousel.EventStore();
    }

    /**
     * Initializes the carousel scroll components with the provided state.
     *
     * @param {Object} state - The state object used to initialize the scroll body and scroll target.
     */
    initialize(state) {
      this.state = state;
      this.baseFriction = this.state.get('friction');
      this.baseDuration = this.state.get('duration');
      this.bindEvents();
      return this;
    }

    /**
     * Binds keyboard event listeners to the carousel's root node.
     * Specifically, adds a 'keydown' event listener that triggers the handleKeyDown method.
     *
     */
    bindEvents() {
      const rootNode = this.state.get('rootNode');
      this.keyboardEvents.add(rootNode, 'keydown', this.handleKeyDown.bind(this));
    }

    /**
     * Scrolls the carousel to the specified index in the given direction.
     * Sets friction and duration to their base values before scrolling.
     * Notifies observers with the scroll action and data.
     *
     * @param {number} index - The index to scroll to.
     * @param {string} direction - The direction of the scroll (e.g., 'left' or 'right').
     */
    scrollTo(index, direction) {
      this.state.setFriction(this.baseFriction);
      this.state.setDuration(this.baseDuration);
      const data = {
        number: index,
        direction
      };
      this.state.notifyObservers('scrollByIndex', data);
    }

    /**
     * Scrolls the carousel to the next item.
     * Increments the current index by 1 and scrolls to the new position.
     */
    scrollNext() {
      const index = this.state.get('index');
      const next = index.add(1).get();
      this.scrollTo(next, -1);
    }

    /**
     * Scrolls the carousel to the previous item.
     * Retrieves the current index from the state, decrements it by one,
     * and scrolls to the resulting index.
     */
    scrollPrevious() {
      const index = this.state.get('index');
      const prev = index.add(-1).get();
      this.scrollTo(prev, 1);
    }

    /**
     * Handles keyboard arrow key events to scroll the carousel.
     * @param {KeyboardEvent} event - The keyboard event triggered by user interaction.
     */
    handleKeyDown(event) {
      switch (event.key) {
        case 'ArrowLeft':
          this.scrollPrevious();
          break;
        case 'ArrowRight':
          this.scrollNext();
          break;
        default:
          break;
      }
    }

    /**
     * Cleans up resources by removing all registered keyboard event listeners.
     * Should be called when the keyboard scroller is no longer needed.
     */
    destroy() {
      this.keyboardEvents.clear();
    }
  }

  global.NewHomeSource.Carousel.KeyboardScroller = KeyboardScroller;
}(window));
